export default __webpack_public_path__ + "images/EN.d740ca9.png";